import { Address, Location } from '../redux/types';

// TODO: format by country instead of a fixed US-style order.
export function formatAddress(address: Address) {
    const stateAndZip = [address.state, address.zipCode].filter(Boolean).join(' ');
    return [...address.streetAddress, address.city, stateAndZip, address.country].filter(Boolean).join(', ');
}

export function findLocationAddress(
    locations: Location[] | undefined,
    code: string,
    type: 'shippingAddress' | 'billingAddress'
): Address | undefined {
    return locations?.find((location) => location.code === code)?.[type];
}
